import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { useWSQuery, WSQueryResult } from "@ws-react-query";

import { useQueryBackgroundChecksSettings } from "../../../query/backgroundChecks/queries/useQueryBackgroundChecksSettings";
import { useQueryMonitorSettings } from "../../../query/monitorSettings/query/useQueryMonitorSettings";
import { useQuerySharedFileSettings } from "../../../query/sharedFile/query/useQuerySharedFileSettings";
import { useQuerySignedDocumentTemplate } from "../../../query/signedDocuments/query/useQuerySignedDocumentTemplate";
import { RequirementDefinitionSettingsItem } from "../types";

export const useRequirementDefinitionSettings = (props?: {
  dataSourceId?: string;
  requirementType?: RequirementType;
}): WSQueryResult<RequirementDefinitionSettingsItem, any> => {
  const dataSourceId = props?.dataSourceId as string;
  const requirementType = props?.requirementType as RequirementType;
  const enabled = !!dataSourceId;

  const signedDocumentTemplateQuery = useQuerySignedDocumentTemplate(
    dataSourceId,
    {
      enabled: props?.requirementType === RequirementType.Signature && enabled
    }
  );
  const sharedFileSettingsQuery = useQuerySharedFileSettings(dataSourceId, {
    enabled: requirementType === RequirementType.SharedFile && enabled
  });

  const backgroundChecksSettingsQuery = useQueryBackgroundChecksSettings(
    dataSourceId,
    {
      enabled: requirementType === RequirementType.BackgroundCheck && enabled
    }
  );

  const monitorSettingsQuery = useQueryMonitorSettings(dataSourceId, {
    enabled: requirementType === RequirementType.InsuranceCoverage && enabled
  });

  switch (requirementType) {
    case RequirementType.BackgroundCheck:
      return backgroundChecksSettingsQuery;
    case RequirementType.Signature:
      return signedDocumentTemplateQuery;
    case RequirementType.SharedFile:
      return sharedFileSettingsQuery;
    case RequirementType.InsuranceCoverage:
      return monitorSettingsQuery;
    default:
      return {
        data: undefined,
        isDisabled: true,
        isError: false,
        isInitialLoading: false,
        isLoading: false
      } as any;
  }
};
